import { Component, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Region } from '@boels/models';
import { CmsRouterLinkDirective, StoreFinderFacade } from '@boels/shared-state';
import { AsyncPipe } from '@angular/common';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { Params } from '@angular/router';
import { RoutingService } from '@boels/helpers';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { VerticalAlignerComponent } from '../../vertical-aligner/vertical-aligner.component';

@Component({
  selector: 'boels-store-finder-region',
  templateUrl: './store-finder-region.component.html',
  styleUrls: ['./store-finder-region.component.scss'],
  imports: [
    AsyncPipe,
    CmsRouterLinkDirective,
    TranslocoModule,
    VerticalAlignerComponent,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['storeFinder'],
    },
  ],
})
export class StoreFinderRegionComponent {
  #storeFinderFacade = inject(StoreFinderFacade);
  #routingService = inject(RoutingService);

  stores$: Observable<Region[]> = this.#storeFinderFacade.getStoresByRegion();
  specialismParam$: Observable<Params> = this.#routingService
    .getRoutePropertyAsObservable('queryParams')
    .pipe(
      takeUntilDestroyed(),
      map((params: Params | undefined) => {
        const filteredParams: Params = {};
        const specialismQueryParam = params?.['specialism'];
        if (specialismQueryParam) {
          filteredParams['specialism'] = specialismQueryParam;
        }
        return filteredParams;
      }),
    );
}
